import React from "react";
import { TextField } from "@mui/material";

interface ContactInformationProps {
  values: {
    firstName: string;
    middleName: string;
    lastName: string;
    dob: string;
    city: string;
    street: string;
    state: string;
    zipcode: string;
    phoneNumber: string;
    email: string;
  };
  errors: {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    dob?: string;
    city?: string;
    street?: string;
    state?: string;
    zipcode?: string;
    phoneNumber?: string;
    email?: string;
  };
  touched: {
    firstName?: boolean;
    middleName?: boolean;
    lastName?: boolean;
    dob?: boolean;
    city?: boolean;
    street?: boolean;
    state?: boolean;
    zipcode?: boolean;
    phoneNumber?: boolean;
    email?: boolean;
  };
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setFieldValue: (field: string, value: any) => void;
}

const ContactInformation: React.FC<ContactInformationProps> = ({
  values,
  errors,
  touched,
  handleChange,
}) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    {/* First Name */}
    <TextField
      label="First Name *"
      name="firstName"
      value={values.firstName}
      onChange={handleChange}
      error={touched.firstName && Boolean(errors.firstName)}
      helperText={touched.firstName && errors.firstName}
      fullWidth
      InputProps={{ style: { borderRadius: 10 } }}
    />

    {/* Middle Name */}
    <TextField
      label="Middle Name"
      name="middleName"
      value={values.middleName}
      onChange={handleChange}
      error={touched.middleName && Boolean(errors.middleName)}
      helperText={touched.middleName && errors.middleName}
      fullWidth
      InputProps={{ style: { borderRadius: 10 } }}
    />

    {/* Last Name */}
    <TextField
      label="Last Name *"
      name="lastName"
      value={values.lastName}
      onChange={handleChange}
      error={touched.lastName && Boolean(errors.lastName)}
      helperText={touched.lastName && errors.lastName}
      fullWidth
      InputProps={{ style: { borderRadius: 10 } }}
    />

    {/* Date of Birth */}
    <TextField
      label="Date of Birth *"
      name="dob"
      type="date"
      value={values.dob}
      onChange={handleChange}
      error={touched.dob && Boolean(errors.dob)}
      helperText={touched.dob && errors.dob}
      fullWidth
      inputProps={{
        max: new Date().toISOString().split("T")[0], // Prevent selecting future dates
      }}
      InputLabelProps={{ shrink: true }}
      InputProps={{ style: { borderRadius: 10 } }}
    />

    {/* Phone number */}
    <TextField
      label="Phone Number *"
      name="phoneNumber"
      value={values.phoneNumber}
      onChange={handleChange}
      error={touched.phoneNumber && Boolean(errors.phoneNumber)}
      helperText={touched.phoneNumber && errors.phoneNumber}
      fullWidth
      InputProps={{ style: { borderRadius: 10 } }}
    />
 
    <TextField
      label="Email *"
      name="email"
      value={values.email}
      onChange={handleChange}
      error={touched.email && Boolean(errors.email)}
      helperText={touched.email && errors.email}
      fullWidth
      InputProps={{ style: { borderRadius: 10 } }}
    />

    {/* Street */}
    <TextField
      label="Street *"
      name="street"
      value={values.street}
      onChange={handleChange}
      error={touched.street && Boolean(errors.street)}
      helperText={touched.street && errors.street}
      fullWidth
      InputProps={{ style: { borderRadius: 10 } }}
    />

    {/* City */}
    <TextField
      label="City *"
      name="city"
      value={values.city}
      onChange={handleChange}
      error={touched.city && Boolean(errors.city)}
      helperText={touched.city && errors.city}
      fullWidth
      InputProps={{ style: { borderRadius: 10 } }}
    />

    {/* State */}
    <TextField
      label="State *"
      name="state"
      value={values.state}
      onChange={handleChange}
      error={touched.state && Boolean(errors.state)}
      helperText={touched.state && errors.state}
      fullWidth
      InputProps={{ style: { borderRadius: 10 } }}
    />

    {/* Zipcode */}
    <TextField
      label="Zipcode *"
      name="zipcode"
      value={values.zipcode}
      onChange={handleChange}
      error={touched.zipcode && Boolean(errors.zipcode)}
      helperText={touched.zipcode && errors.zipcode}
      fullWidth
      InputProps={{ style: { borderRadius: 10 } }}
    />
  </div>
);

export default ContactInformation;
